import { useCallback, useEffect } from 'react'

import { useAuth } from '@/plugins/auth'
import { saveLocation } from '@/plugins/auth/RouteRedirectors/utils'

import useLocalStorage from './useLocalStorage'

const useLoginOnAction = (name: string, goTo: () => void) => {
  const [triedToLogin, setTriedToLogin] = useLocalStorage<boolean>(`triedToLogin`, false)
  const [triedToAct, setTriedToAct] = useLocalStorage<boolean>(`triedToAct-${name}`, false)
  const { status, connect } = useAuth()
  const handleNavigation = useCallback(() => {
    if (status === 'connected') {
      goTo()
      setTriedToAct(false)
    }
    if (status === 'disconnected') {
      saveLocation(window.location.pathname)
      setTriedToAct(true)
      connect()
    }
  }, [status, connect, goTo])

  useEffect(() => {
    if (triedToAct) {
      setTriedToLogin(status === 'connecting')
      if (triedToLogin && status === 'connected') {
        goTo()
        setTriedToAct(false)
      }
    }
  }, [triedToAct, triedToLogin, status])

  return { handleNavigation }
}

export default useLoginOnAction
